import React, { useState } from "react";
import styled from "styled-components";
import { useRecuperarSenha } from "../../../Hooks/Usuario/useRecuperarSenha";

const CardEsqueceuSenha = ({ onSwitch }) => {
  const [email, setEmail] = useState("");
  const { recuperar, loading, erro, sucesso } = useRecuperarSenha();

  const handleEnviarLink = async (e) => {
    e.preventDefault();
    if (!email) return;
    await recuperar(email);
  };

  return (
    <StyledWrapper>
      <div className="form-container">
        <p className="title">Recuperar Senha</p>
        <form className="form" onSubmit={handleEnviarLink}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="seuemail@exemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div><br />
          <button className="sign" type="submit" disabled={loading}>
            {loading ? "Enviando..." : "Enviar link"}
          </button>
          {sucesso && !erro && <SuccessP>Senha enviada para seu e-mail!</SuccessP>}
          {erro && <ErrorP>{erro}</ErrorP>}
        </form>
        <p className="signup" style={{ marginTop: 20 }}>
          Lembrou sua senha?{" "}
          <a href="#" onClick={(e) => { e.preventDefault(); onSwitch("login"); }}>
            Voltar ao login
          </a>
        </p>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .form-container {
    width: 100%;
    border-radius: 0.75rem;
    background-color: #111827;
    padding: 2rem;
    color: rgba(243, 244, 246, 1);
  }

  .title {
    text-align: center;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
  }

  .form {
    margin-top: 1.5rem;
  }

  .input-group {
    margin-top: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .input-group label {
    display: block;
    color: rgba(156, 163, 175, 1);
    margin-bottom: 4px;
  }

  .input-group input {
    width: 100%;
    border-radius: 0.375rem;
    border: 1px solid rgba(55, 65, 81, 1);
    outline: 0;
    background-color: rgba(17, 24, 39, 1);
    padding: 0.75rem 1rem;
    color: rgba(243, 244, 246, 1);
  }

  .input-group input:focus {
    border-color: rgba(167, 139, 250);
  }

  .sign {
    display: block;
    width: 100%;
    background-color: #a78bfa;
    padding: 0.75rem;
    text-align: center;
    color: #111827;
    border: none;
    border-radius: 0.375rem;
    font-weight: 600;
    cursor: pointer;
  }

  .sign:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .signup {
    text-align: center;
    font-size: 0.75rem;
    line-height: 1rem;
    color: rgba(156, 163, 175, 1);
  }

  .signup a {
    color: rgba(243, 244, 246, 1);
    text-decoration: none;
    font-size: 14px;
  }

  .signup a:hover {
    text-decoration: underline #a78bfa;
  }
`;

const ErrorP = styled.p`
  color: #f87171; /* vermelho claro */
  margin-top: 8px;
  font-size: 0.875rem;
`;

const SuccessP = styled.p`
  color: #4ade80; /* verde claro */
  margin-top: 8px;
  font-size: 0.875rem;
`;

export default CardEsqueceuSenha;
